// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-container {
  display: inline-block;
  margin: 10px;
}

.circular {
  position: relative;
  width: 100px;
  height: 100px;
}

.circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform: rotate(-90deg);
  transition: stroke-dashoffset 0.5s ease, background 0.2s linear;
  background: conic-gradient(#3498db 0deg, #ddd 0deg);
}

.circle-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.circle-label {
  display: block;
  font-size: 14px;
  color: #555;
}

.circle-percentage {
  display: block;
  font-size: 18px;
  font-weight: bold;
  color: #3498db;
}
`, "",{"version":3,"sources":["webpack://./src/components/OLTManage/CircularProgress.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,+DAA+D;EAC/D,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".circular-container {\n  display: inline-block;\n  margin: 10px;\n}\n\n.circular {\n  position: relative;\n  width: 100px;\n  height: 100px;\n}\n\n.circle {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  transform: rotate(-90deg);\n  transition: stroke-dashoffset 0.5s ease, background 0.2s linear;\n  background: conic-gradient(#3498db 0deg, #ddd 0deg);\n}\n\n.circle-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.circle-label {\n  display: block;\n  font-size: 14px;\n  color: #555;\n}\n\n.circle-percentage {\n  display: block;\n  font-size: 18px;\n  font-weight: bold;\n  color: #3498db;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
